import client from '../axios';
import type {
  AddFundDownloadRequest,
  AddFundingResponse,
  AddFundsUsaInstructions,
  AddFundsUsaInstructionsRequest,
} from './types';

const addFundDownload = async ({
  enterpriseId,
  currency,
  walletId,
}: AddFundDownloadRequest): Promise<AddFundingResponse> => {
  const baseUrl = `add-funds-pdf/${enterpriseId}/${currency}/`;
  const url = walletId ? `${baseUrl}?wallet_id=${walletId}` : baseUrl;
  return client.get(url);
};

const addFundsUsaInstructions = async ({
  enterpriseId,
  currency,
  walletId,
}: AddFundsUsaInstructionsRequest): Promise<AddFundsUsaInstructions> => {
  const baseUrl = `add-funds/${enterpriseId}/${currency}/`;
  const url = walletId ? `${baseUrl}?wallet_id=${walletId}` : baseUrl;
  return client.get(url);
};

const getPaymentReasons = async (): Promise<{ id: number; name: string }[]> =>
  client.get('payments/payment-reasons/');

const fundingSvc = {
  addFundDownload,
  addFundsUsaInstructions,
  getPaymentReasons,
};

export default fundingSvc;
